export default __webpack_public_path__ + "static/media/shopping_cart.8b884465.svg";